module.exports = __webpack_public_path__ + "static/media/barnaul.6fcc247c.svg";